export const defaultPalette = {
	primary: {
		main: "#3899EC",
		light: "#CAE0E7",
		dark: "#2B7CD3",
		contrastText: "#ffffff",
	},
	secondary: {
		main: "#3083dcff",
		light: "#E0F0F6",
		dark: "#27578aff",
		contrastText: "#3D3D3D",
	},
	success: {
		main: "#13DEB9",
		light: "#E6FFFA",
		dark: "#02b3a9",
		contrastText: "#ffffff",
	},
	info: {
		main: "#539BFF",
		light: "#EBF3FE",
		dark: "#1682d4",
		contrastText: "#ffffff",
	},
	error: {
		main: "#FA896B",
		light: "#FDEDE8",
		dark: "#f3704d",
		contrastText: "#ffffff",
	},
	warning: {
		main: "#FFAE1F",
		light: "#FEF5E5",
		dark: "#ae8e59",
		contrastText: "#ffffff",
	},
	purple: {
		A50: "#EBF3FE",
		A100: "#6610f2",
		A200: "#557fb9",
	},
	grey: {
		100: "#F2F6FA",
		200: "#EAEFF4",
		300: "#DFE5EF",
		400: "#7C8FAC",
		500: "#5A6A85",
		600: "#2A3547",
	},
	text: {
		primary: "#2A3547",
		secondary: "#2A3547",
	},
	action: {
		disabledBackground: "rgba(73,82,88,0.12)",
		hoverOpacity: 0.02,
		hover: "#f6f9fc",
	},
	divider: "#e5eaef",
	background: {
		default: "#ffffff",
	},
};
